import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class MetaDataService {
	constructor(private httpService: HttpClient) { }

	getAction(data:any){
		return this.httpService.post('/soccerAction/allList', {});
	}

	createOpta(usertObj:any) {
		return this.httpService.post('/opta/create', usertObj);
	}
	
	getOptaList(filterObj:any) {
		return this.httpService.post('/opta/list', filterObj);
	}

	deleteOpta(data:any) {
		return this.httpService.post('/opta/change-status', data);
	}

	getOptaDetail(optaid:any) {
		return this.httpService.get('/opta/' + optaid);
	}

	updateOpta(optaId:any, optaObj:any) {
		return this.httpService.put('/opta/' + optaId, optaObj);
	}

	postMetaData(data:any) {
		return this.httpService.post('/opta/post', data);
	}

	eraseMetaData(data:any) {
		return this.httpService.post('/opta/erase', data);
	}

	updateStatus( optaObj:any) {
		return this.httpService.post('/opta/updateStatus', optaObj);
	}

	updateMatchStatus( id:any) {
		return this.httpService.post('/videoListing/updateStatus', {id:id});
	}

	deleteOptaList(data:any) {
		return this.httpService.post('/opta/delete', data);
	}

	changeStatus(data:any) {
		return this.httpService.post('/opta/change-status', data);
	}

	UpdatePushedOnLvs(data:any){
		return this.httpService.post('/opta/UpdatePushedOnLvs', data);
	}

	getActiveParserList(){
		return this.httpService.get('/parser/fetchlist');
	}
}
